// helper functions for m9 digital

// selecting elements

// select a list of matching elements, context is optional
function $qAll(selector, context) {
    return (context || document).querySelectorAll(selector);
}

// select the first match only, context is optional
function $q1(selector, context) {
    return (context || document).querySelector(selector);
}

// has, add, remove Class
function hasClassN(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

function addClassN(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClassN(el, className)) el.className += ' ' + className;
}

function removeClassN(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}

function toggleClassN(el, className, callback) {
    el.classList.toggle(className);
    if(callback && callback.typeOf === 'function') {
        callback();
    }
}

// debounced resize

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// get current screenSize

function currScreenSize() {
    var head = document.getElementsByTagName( 'head' )[ 0 ];
    var computed;

    if ( window.getComputedStyle ) {
        computed = window.getComputedStyle( head, null );
    } else if ( document.documentElement.currentStyle ) {
        computed = head.currentStyle;
    }
    var size = computed.fontSize;
    size = parseInt( size, 10 );
    var screenDef;

    if ( size === 10 ) {
        // small screen
        screenDef = 'ss';
    } else if ( size === 20 ) {
        // midi screen
        screenDef = 'ms';
    } else if ( size === 30 ) {
        // large screen
        screenDef = 'ls';
    } else if ( size === 40 ) {
        screenDef = 'xls';
    }
    else if ( size === 50 ) {
        screenDef = 'xxl';
    }
    else if ( size === 60 ) {
        screenDef = 'massive';
    }

    return screenDef;
}


function toggleAriaExpanded (element) {
    const attributeKey = 'aria-expanded';

    let currentAriaState = element.getAttribute(attributeKey);

    switch (currentAriaState) {
        case 'true':
            element.setAttribute(attributeKey, 'false');
            break;
        case 'false':
            element.setAttribute(attributeKey, 'true');
            break;
        default:

    }
}

function canHover () {
    // if we have proper hover

    const docEl = document.documentElement;

    if(window.matchMedia('(hover: hover)').matches) {
        addClassN(docEl, 'is-hover-device');
    }
}



export { $qAll, $q1, hasClassN,  addClassN, removeClassN, toggleClassN, debounce, currScreenSize, toggleAriaExpanded, canHover };
